import { handleAsyncBookingEvent } from '../../store/Bookings/actions';
import { RootReducerState } from '../../store/reducer';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

interface BookingAsyncData {
  id: number;
}

export default function BookingAsyncRefresh() {
  const dispatch = useDispatch();
  const branch = useSelector(
    (state: RootReducerState) => state.dashboard.selectedBranch
  );

  /**
   * Register Echo channel listener
   */
  useEffect(() => {
    const channel = window.Echo.private(`branch.${branch.id}.booking`);

    console.log(`Registered async listener channel .booking.created`);
    channel.listen('.booking.created', function ({ id }: BookingAsyncData) {
      console.log('Received async event .booking.created', id);
      dispatch(handleAsyncBookingEvent(branch.id, id, 'create'));
    });

    console.log(`Registered async listener channel .booking.updated`);
    channel.listen('.booking.updated', function ({ id }: BookingAsyncData) {
      console.log('Received async event .booking.updated', id);
      dispatch(handleAsyncBookingEvent(branch.id, id, 'update'));
    });

    console.log(`Registered async listener channel .booking.deleted`);
    channel.listen('.booking.deleted', function ({ id }: BookingAsyncData) {
      console.log('Received async event .booking.deleted', id);
      dispatch(handleAsyncBookingEvent(branch.id, id, 'delete'));
    });

    return () => {
      channel.stopListening('.booking.created');
      channel.stopListening('.booking.updated');
      channel.stopListening('.booking.deleted');

      window.Echo.leave(`branch.${branch.id}.booking`);
    };
  }, []);

  return <div className="fixed"></div>;
}
